





























import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { CalendarIcon } from 'vue-feather-icons';

@Component({
  components: { CalendarIcon },
})
export default class FormDateInput extends mixins(BaseMixin) {
  @Prop({ required: false, type: [Date, String] })
  readonly value!: Date | string;

  @Prop({ required: false, type: String, default: () => 'Fälligkeitsdatum wählen' })
  readonly placeholder!: string;

  /** Anzeigeformat im Eingabefeld (v-calendar). */
  @Prop({ required: false, type: Object, default: () => ({ input: 'DD.MM.YYYY' }) })
  readonly masks!: { input: string };

  model?: Date = new Date();

  mounted() {
    if (this.value) {
      this.model = new Date(this.value);
    } else {
      this.model = undefined;
    }
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.model = new Date(this.value);
    }
  }

  @Prop({ required: false, type: Array })
  errors!: string[];

  handleInput() {
    this.$emit('input', this.model);
  }

  attrs = [
    {
      key: 'today',
      dot: true,
      dates: new Date(),
    },
  ];
}
